import { Form, Formik, FormikHelpers } from 'formik'
import { FC, useEffect } from 'react'
import * as Yup from 'yup'
import { sendPasswordResetEmail } from 'firebase/auth'
import { auth } from '../../../../../firebase'
import { sileo } from 'sileo'
import { UserAuth } from '../../../../../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { FieldWithErrorMessage } from '../../../ui/FieldWithErrorMsg'

type FormValues = { email: string }

const validationSchema = Yup.object<FormValues>({
  email: Yup.string().email('Ingresa un correo valido').required('Ingresa tu correo')
})

export const ResetPassword: FC = () => {
  const { user, isAuthenticated } = UserAuth()
  const navigate = useNavigate()

  const handleResetPassword = async (values: FormValues, actions: FormikHelpers<FormValues>) => {
    try {
      actions.resetForm()
      await sendPasswordResetEmail(auth, values.email)

      sileo.success({
        title: 'Verificación en curso',
        description: (
          <span className='text-green-500/80 font-medium'>
            Hemos enviado un correo de recuperación a tu cuenta. 👌
          </span>
        )
      })
      actions.setSubmitting(false)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (user && isAuthenticated) {
      navigate('/', { replace: true })
    }
  }, [user, isAuthenticated])

  return (
  <div className='w-full max-w-md'>
    <Formik
      initialValues={{ email: '' }}
      validationSchema={validationSchema}
      onSubmit={handleResetPassword}
    >
      {({ errors, touched }) => (
       <Form
          className='flex flex-col gap-8 bg-transparent lg:bg-white p-10 rounded-2xl shadow-lg  border border-white/20 lg:border-gray-100 text-white lg:text-gray-800' >
          {/* 🔹 TÍTULO */}
          <h1 className='text-2xl font-semibold text-white lg:text-gray-800'>
            Restablecer contraseña
          </h1>

          {/* 🔹 DESCRIPCIÓN */}
          <p className='text-sm text-white/70 lg:text-gray-500'>
            Te enviaremos un enlace para recuperar tu contraseña.
          </p>

          {/* 🔹 INPUT */}
          <div>
            <FieldWithErrorMessage
              name='email'
              type='email'
              label='Ingresa tu correo'
              placeholder='correo@empresa.com'
            />
          </div>

          {/* 🔹 BOTÓN */}
          <button
            type='submit'
            className='w-full py-4 rounded-xl bg-primary text-white font-semibold text-sm shadow-md flex items-center justify-center gap-2'
          >
            Enviar
          </button>
        </Form>
      )}
    </Formik>
  </div>
)
}
